<template>
  <div style="background-color: white; height: 100%; width: 100%">
    <el-row>
      <el-col :span="8">
        <div class="down-tree" style="height: 600px; border: 1px solid #000">
          <el-input placeholder="输入关键字进行过滤" v-model="filterText">
          </el-input>
          <el-tree
            :data="data"
            ref="tree"
            :props="defaultProps"
            node-key="id"
            @node-expand="handleNodeExpand"
            @node-collapse="handleNodeCollapse"
            :default-expanded-keys="defaultExpandIds"
            draggable
            @node-click="handleNodeClick"
            class="filter-tree"
            :filter-node-method="filterNode"
            @node-drop="handleDrop"
          ></el-tree>
        </div>
      </el-col>
      <el-col :span="12">
        <div style="margin-top: 50px; margin-left: 50px">
          <el-form label-width="120px" :model="form">
            <el-form-item label="当前选中">
              <el-input
                v-model.trim="form.companyName"
                :readonly="true"
              ></el-input>
            </el-form-item>
            <el-form-item label="单位名称">
              <el-input v-model.trim="form.newName"></el-input>
            </el-form-item>
            <el-form-item label="项目所属区域" v-if="personCode == 'G115'">
              <el-cascader
                style="width: 100%"
                ref="cascader"
                class="cascader"
                v-if="addressPro"
                v-model="form.addressIds"
                :props="propsAddress"
                @change="handleCascaderChange"
                :placeholder="addressPro"
              />
              <el-cascader
                style="width: 100%"
                v-else
                ref="cascader"
                v-model="form.addressIds"
                :props="propsAddress"
                @change="handleCascaderChange"
                placeholder="选择所属地域"
              />
            </el-form-item>
            <el-form-item label="项目详细地址" v-if="personCode == 'G115'">
              <el-input
                placeholder="请输入详细地址"
                v-model.trim="form.addressDetail"
              ></el-input>
            </el-form-item>
            <el-form-item label="项目地图坐标" v-if="personCode == 'G115'">
              <el-input
                placeholder="请选择地图坐标"
                v-model.trim="form.addressCoordinate"
                :readonly="true"
              >
                <el-button
                  icon="el-icon-search"
                  slot="append"
                  circle
                  @click="selectAddressHandle"
                ></el-button>
              </el-input>
            </el-form-item>
            <el-button
              type="primary"
              v-preventReClick
              @click="addBigCompany"
              icon="el-icon-plus"
              >新增单位</el-button
            >
            <el-button
              type="primary"
              v-preventReClick
              @click="handleCreate"
              icon="el-icon-plus"
              >新增子单位</el-button
            >
            <el-button
              type="primary"
              v-preventReClick
              @click="handleCreate1"
              icon="el-icon-edit"
              >修改选中单位</el-button
            >
            <el-button
              type="danger"
              v-preventReClick
              @click="handleCreate2"
              icon="el-icon-delete"
              >删除</el-button
            >
          </el-form>
        </div>
      </el-col>
    </el-row>
    <!-- 添加 -->
    <el-dialog
      :visible.sync="selectAddressShow"
      title="选择位置"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="60%"
    >
      <el-row>
        <TdMap :currNode="currNode" @selectAddressOk="selectAddressOk"></TdMap>
      </el-row>
    </el-dialog>
  </div>
</template>
<script>
import {
  treeCompany,
  addCompany,
  updCompany,
  delCompany,
  addBigCompany,
  selectArea,
} from "../../api/api";
import TdMap from "../market/components/TdMap.vue";
export default {
  name: "Company",
  components: {
    TdMap,
  },
  data() {
    return {
      defaultExpandIds: [],
      data: [],
      defaultProps: {
        children: "zcompany",
        label: "companyName",
      },
      personCode: null,
      propsAddress: {
        lazy: true,
        lazyLoad(node, resolve) {
          const { value } = node;
          let nodes = [];
          selectArea({ pid: value ? value : 0 }).then((datas) => {
            let { status, data } = datas;
            if (status == 200) {
              data.forEach((item) => {
                nodes.push({
                  label: item.name,
                  value: item.id,
                  leaf: item.deep == 2 ? true : false,
                  latitude: item.latitude,
                  longitude: item.longitude,
                  extPath: item.extPath,
                });
              });
            }
            resolve(nodes);
          });
        },
      },
      options: [],
      addressPro: null,
      form: {
        companyCode: "",
        companyName: "",
        personCode: "",
        newName: "",
      },
      filterText: "",
      tableData: [],
      selectAddressShow: false,
      currNode: {},
    };
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  methods: {
    handleNodeExpand(data) {
      // 保存当前展开的节点
      let flag = false;
      this.defaultExpandIds.some((item) => {
        if (item === data.id) {
          // 判断当前节点是否存在， 存在不做处理
          flag = true;
          return true;
        }
      });
      if (!flag) {
        // 不存在则存到数组里
        this.defaultExpandIds.push(data.id);
      }
    },
    selectAddressHandle() {
      if (!this.form.addressIds) {
        this.$message({
          message: "请先选择所属区域",
          type: "error",
        });
        return;
      }
      this.selectAddressShow = true;
    },
    selectAddressOk(lat_long) {
      this.$nextTick(() => {
        this.form.addressCoordinate = lat_long;
      });
      this.selectAddressShow = false;
    },
    //隐藏地址选择下拉
    handleCascaderChange(e) {
      this.$refs.cascader.dropDownVisible = false;
      this.currNode = this.$refs.cascader.getCheckedNodes();
      this.$nextTick(() => {
        this.form.addressCoordinate = "";
      });
    },
    // 树节点关闭
    handleNodeCollapse(data) {
      // 删除当前关闭的节点
      this.defaultExpandIds.some((item, i) => {
        if (item === data.id) {
          this.defaultExpandIds.splice(i, 1);
        }
      });
      this.removeChildrenIds(data); // 这里主要针对多级树状结构，当关闭父节点时，递归删除父节点下的所有子节点
    },
    // 删除树子节点
    removeChildrenIds(data) {
      const ts = this;
      if (data.children) {
        data.children.forEach(function (item) {
          const index = ts.defaultExpandIds.indexOf(item.id);
          if (index > 0) {
            ts.defaultExpandIds.splice(index, 1);
          }
          ts.removeChildrenIds(item);
        });
      }
    },
    handleDrop(draggingNode, dropNode, dropType, ev) {
      this.$confirm("此操作将修改单位信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          var map = {};
          if (dropType == "after") {
            map = {
              companyCode: draggingNode.data.companyCode,
              companyName: draggingNode.data.companyName,
              personCode:
                dropNode.data.personCode == ""
                  ? "-1"
                  : dropNode.data.personCode,
            };
          } else if (dropType == "inner") {
            map = {
              companyCode: draggingNode.data.companyCode,
              companyName: draggingNode.data.companyName,
              personCode:
                dropNode.data.companyCode == ""
                  ? "-1"
                  : dropNode.data.companyCode,
            };
          } else {
            map = {
              companyCode: draggingNode.data.companyCode,
              companyName: draggingNode.data.companyName,
              personCode:
                dropNode.data.personCode == ""
                  ? "-1"
                  : dropNode.data.personCode,
            };
          }
          updCompany(map).then((datas) => {
            let { status, message } = datas;
            if (status == 400) {
              this.$message({
                message: message,
                type: "error",
              });
              this.findAll();
            } else if (status == 200) {
              this.$message({
                message: "修改成功",
                type: "success",
              });
              this.form = {};
              // this.findAll();
            } else {
              this.$message({
                message: "请求错误",
                type: "error",
              });
            }
          });
        })
        .catch(() => {
          this.findAll();
          this.$message({
            type: "info",
            message: "已取消修改",
          });
        });
    },
    handleNodeClick(data) {
      this.personCode = data.personCode;
      this.form = data;
      this.addressPro = data.addressName;
      if (data.addressId) {
        this.form.addressIds = [0, 0, data.addressId];
      }
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.companyName.indexOf(value) !== -1;
    },
    //添加子单位
    handleCreate() {
      var map = {
        companyCode: this.form.companyCode,
        companyName: this.form.newName,
        personCode: this.form.personCode,
      };
      addCompany(map).then((datas) => {
        let { status, message } = datas;
        if (status == 400) {
          this.$message({
            message: message,
            type: "error",
          });
        } else if (status == 200) {
          this.$message({
            message: "添加成功",
            type: "success",
          });
          this.from = {};
          this.findAll();
        } else {
          this.$message({
            message: "请求错误",
            type: "error",
          });
        }
      });
    },
    //增加dad
    addBigCompany() {
      var map = {
        companyName: this.form.newName,
      };
      addBigCompany(map).then((datas) => {
        let { status, message } = datas;
        if (status == 400) {
          this.$message({
            message: message,
            type: "error",
          });
        } else if (status == 200) {
          this.$message({
            message: "添加成功",
            type: "success",
          });
          this.form = {};
          this.findAll();
        } else {
          this.$message({
            message: "请求错误",
            type: "error",
          });
        }
      });
    },
    //修改选中单位
    handleCreate1() {
      var s = {
        companyCode: this.form.companyCode,
        companyName: this.form.newName,
        personCode: this.form.personCode,
        addressIds: this.form.addressIds,
        addressDetail: this.form.addressDetail,
        addressCoordinate: this.form.addressCoordinate,
      };
      updCompany(s).then((datas) => {
        let { status, message } = datas;
        if (status == 400) {
          this.$message({
            message: message,
            type: "error",
          });
        } else if (status == 200) {
          this.$message({
            message: "添加成功",
            type: "success",
          });
          this.form = {};
          this.findAll();
        } else {
          this.$message({
            message: "请求错误",
            type: "error",
          });
        }
      });
    },
    //删除选中单位
    handleCreate2() {
      this.$confirm("此操作将永久删除该单位, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        delCompany(this.form.companyCode).then((datas) => {
          let { status, message } = datas;
          if (status == 400) {
            this.$message({
              message: message,
              type: "warning",
            });
          } else if (status == 200) {
            this.findAll();
            this.form = {};
            this.$message({
              type: "success",
              message: "删除成功!",
            });
          } else {
            this.$message({
              message: "请求错误",
              type: "error",
            });
          }
        });
      });
    },
    findAll() {
      treeCompany().then((datas) => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.data = data;
        }
      });
    },
  },
  created() {
    this.findAll();
  },
};
</script>
<style >
.el-checkbox__inner {
  border: 1px solid #606266 !important;
}
</style>
<style scoped>
.down-tree {
  display: block;

  overflow-y: scroll;
}
</style>



// WEBPACK FOOTER //
// src/views/SystemSettings/Company.vue